export { TooltipDirective } from "./tooltip.directive";
